import { useSupabaseQuery } from './useSupabaseQuery';
import type { PaymentIntent } from '../types/database';

export function usePaymentIntents(orderId: string | undefined) {
	return useSupabaseQuery<PaymentIntent>(
		(client) =>
			client
				.from('payment_intents')
				.select('*')
				.eq('order_id', orderId ?? '')
				.order('created_at', { ascending: false }),
		[orderId]
	);
}
